/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ view: NonNullable<unknown> }} Consumption_View_IncompatibleInputs */



/**
* | output |
* | --- |
* | "Unavailable with the chosen comparison: use the {view} view or remove the comparison." |
*
* @param {Consumption_View_IncompatibleInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const consumption_view_incompatible = /** @type {((inputs: Consumption_View_IncompatibleInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Consumption_View_IncompatibleInputs, { locale?: "fr" | "en" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ (`Unavailable with the chosen comparison: use the ${i?.view} view or remove the comparison.`)
	return /** @type {LocalizedString} */ (`Indisponible avec la comparaison choisie : utilisez la vue ${i?.view} ou retirez la comparaison.`)
});